import React from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { DEMAND_STYLE } from '@/lib/market'
import { cn } from '@/lib/utils'
import type { MarketDemand } from '@/types/market'

/** Market demand as an impact-badge chip, with the server's evidence sentence on hover. */
export default function DemandChip({
  demand,
  label,
  sentence,
  className,
}: {
  demand: MarketDemand
  label: string
  sentence?: string | null
  className?: string
}) {
  const chip = (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium',
        DEMAND_STYLE[demand].chip,
        className
      )}
    >
      {demand !== 'unknown' && <span className={cn('h-1.5 w-1.5 rounded-full', DEMAND_STYLE[demand].dot)} />}
      {label}
    </span>
  )
  if (!sentence) return chip
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            className="cursor-help rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
          >
            {chip}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs">{sentence}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
